@if(isBrowser && images?.length > 0){
<div id="lightGallery" class="hidden-images-array">
  <lightgallery [settings]="settings">
    @for(image of images; track image.id){
    <a href="{{ image.preview }}">
      <img className="img-responsive" alt="{{ image.name }}" src="{{ image.preview }}" />
    </a>
    }
  </lightgallery>
</div>
}



<div class="outer-img-wrapper">
  <a [routerLink]="slug ? ['/',vehicleTypeService.currentVehicleType,'product', slug] : null" [queryParams]="{ modificationId: selectedModificationService?.selectedModificationId }" (click)="
      images?.length > 0 && openLightGallery(index ? index : 0);
      closeCartSidebar()
    ">
    <ng-content></ng-content>
  </a>
</div>

@if(showImageExplanation){
<div class="image-explanation-text-block">
  <span class="pi pi-exclamation-circle"></span>
  <span class="text">Myndirnar eru eingöngu til skýringar og gæti ekki verið nákvæm lýsing af vörunni.</span>
</div>
}
